<template>
  <div class="models-page white-theme">
    <div class="container">
      <div class="page-header text-center">
        <span class="section-tag">{{ $t('home.models.tag') }}</span>
        <h1 class="section-title">{{ $t('home.models.title') }}</h1>
        <p class="section-subtitle">{{ $t('home.models.subtitle') }}</p>
      </div>
      <div class="filter-bar">
        <button v-for="f in filters" :key="f.key" :class="['filter-btn', { active: activeFilter === f.key }]" @click="activeFilter = f.key">
          {{ f.label }}
        </button>
      </div>
      <div class="models-section" v-if="activeFilter === 'all' || activeFilter === 'image'">
        <h2 class="models-section-title">{{ $t('home.models.imageModels') }}</h2>
        <div class="grid-3">
          <router-link v-for="m in imageModels" :key="m.id" :to="langPath(getImageModelPath(m))" class="card model-card">
            <div class="model-card-header">
              <span class="model-icon">{{ getIcon(m.id) }}</span>
              <span v-if="m.badge" class="badge badge-new">{{ m.badge }}</span>
            </div>
            <h3>{{ getModelName(m.id) }}</h3>
            <p class="model-desc">{{ getModelDesc(m.id) }}</p>
            <div class="model-meta">
              <span>{{ m.credits }} {{ $t('home.models.credits') }}</span>
              <span>{{ m.speed }}</span>
            </div>
          </router-link>
        </div>
      </div>
      <div class="models-section" v-if="activeFilter === 'all' || activeFilter === 'video'">
        <h2 class="models-section-title">{{ $t('home.models.videoModels') }}</h2>
        <div class="grid-3">
          <router-link v-for="m in videoModels" :key="m.id" :to="langPath('/models/' + (m.routeId || m.id))" class="card model-card">
            <div class="model-card-header">
              <span class="model-icon">{{ getIcon(m.id) }}</span>
              <span v-if="m.badge" class="badge badge-new">{{ m.badge }}</span>
            </div>
            <h3>{{ getModelName(m.id) }}</h3>
            <p class="model-desc">{{ getModelDesc(m.id) }}</p>
            <div class="model-meta">
              <span>{{ m.credits }} {{ $t('home.models.credits') }}</span>
              <span>{{ m.speed }}</span>
            </div>
          </router-link>
        </div>
      </div>
      <div class="models-section" v-if="activeFilter === 'all' || activeFilter === 'music'">
        <h2 class="models-section-title">{{ $t('home.models.musicModels') }}</h2>
        <div class="grid-3">
          <router-link :to="langPath('/music')" class="card model-card">
            <div class="model-card-header">
              <span class="model-icon">🎵</span>
              <span class="badge badge-new">New</span>
            </div>
            <h3>{{ $t('footer.musicGenerator') }}</h3>
            <p class="model-desc">{{ $t('home.models.musicDesc') }}</p>
            <div class="model-meta">
              <span>10 {{ $t('home.models.credits') }}</span>
              <span>~30s</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var getImageModelPath = require('@/config/imageModelSeoPaths').getImageModelPath

export default {
  name: 'Models',
  data() {
    return {
      activeFilter: 'all'
    }
  },
  computed: {
    filters() {
      return [
        { key: 'all', label: this.$t('home.models.filterAll') },
        { key: 'image', label: this.$t('home.models.imageModels') },
        { key: 'video', label: this.$t('home.models.videoModels') },
        { key: 'music', label: this.$t('home.models.musicModels') }
      ]
    },
    imageModels() { return this.$store.state.imageModels },
    videoModels() { return this.$store.state.videoModels }
  },
  methods: {
    getImageModelPath: function (model) {
      return getImageModelPath(model)
    },
    langPath(path) {
      var lang = this.$route.params.lang
      return lang ? '/' + lang + path : path
    },
    getIcon(id) {
      const icons = { /* 'nano-banana': '🍌', */ 'seedream-4': '🌱', 'seedream-5': '🌱', 'midjourney': '🎨', 'gpt-image-1': '🤖', 'gpt-image-1-5': '🤖', 'pollodance': '🕺', 'seegen': '✨', 'seedance': '💃', 'veo-3-1': '🎥', 'sora-2': '🎬', 'kling-2-6': '🎯', 'kling-3': '🎯', 'wan-2-5': '📊', 'wan-animate': '🎭', 'vidu-q3-pro': '🎞️', 'hailuo-2-3': '🌊', 'runway': '🛤️' }
      return icons[id] || '⚡'
    },
    getModelName(id) {
      const model = this.$store.state.imageModels.find(m => m.id === id) || this.$store.state.videoModels.find(m => m.id === id)
      if (model && model.name) return model.name
      const names = this.$t('models.image')
      return names[id] ? names[id].name : id
    },
    getModelDesc(id) {
      const names = this.$t('models.image')
      const videoNames = this.$t('models.video')
      return (names[id] && names[id].desc) || (videoNames[id] && videoNames[id].desc) || ''
    }
  }
}
</script>

<style scoped>
.models-page { padding: 48px 0 80px; }
.page-header { margin-bottom: 48px; }
.filter-bar { display: flex; gap: 8px; margin-bottom: 32px; flex-wrap: wrap; }
.filter-btn {
  padding: 8px 20px;
  border-radius: var(--radius-full);
  font-size: 13px;
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  transition: all 0.2s;
}
.filter-btn:hover { border-color: #444; color: var(--text-primary); }
.filter-btn.active { background: var(--accent); color: #000; border-color: var(--accent); font-weight: 600; }
.models-section { margin-bottom: 48px; }
.models-section-title { font-size: 20px; font-weight: 700; margin-bottom: 20px; }
.model-card { display: block; }
.model-card-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.model-icon { font-size: 28px; }
.model-card h3 { font-size: 16px; font-weight: 700; margin-bottom: 4px; }
.model-desc { font-size: 13px; color: var(--text-muted); margin-bottom: 12px; }
.model-meta { display: flex; gap: 16px; font-size: 12px; color: var(--text-muted); }
</style>
